import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"clear":"both"} }
const _hoisted_2 = {
  id: "need-help",
  href: "#"
}
const _hoisted_3 = {
  class: "card-text",
  style: {"font-size":"14px"}
}
const _hoisted_4 = {
  key: 0,
  style: {"color":"#999","text-decoration":"underline"}
}
const _hoisted_5 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_col = _resolveComponent("b-col")
  const _component_b_row = _resolveComponent("b-row")
  const _component_b_card = _resolveComponent("b-card")
  const _component_b_collapse = _resolveComponent("b-collapse")
  const _directive_b_toggle = _resolveDirective("b-toggle")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, {
          xs: "12",
          style: {"font-weight":"bold","text-transform":"capitalize"}
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.$t('ml_107034')), 1)
            ])), [
              [
                _directive_b_toggle,
                void 0,
                void 0,
                { contact: true }
              ]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_collapse, { id: "contact" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.numbers, (number, idx) => {
                return (_openBlock(), _createElementBlock("div", { key: idx }, [
                  (number.stringId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t(number.stringId)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    innerHTML: number.content
                  }, null, 8, _hoisted_5)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}